// extracted by mini-css-extract-plugin
export default {"subTitile":"PaymentSuccess_subTitile__C5niD","image":"PaymentSuccess_image__IYtJZ","linkButtons":"PaymentSuccess_linkButtons__Abuss","button":"PaymentSuccess_button__5SGua"};